export default __webpack_public_path__ + "c38b557b12a75e560d4e3098d05b6979.png";